var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotesIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup12",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inbox-show-details",
    transform: "translate(-923.000000, -211.000000)",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(923.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1314",
    points: "5.5160625 8.8741875 7.4673125 8.0379375 6.3523125 6.9223125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.563125,13.7643125 L11.5625,13.7643125 L0.936875,13.7505625 C0.764375,13.7493125 0.624375,13.6099375 0.62375,13.4374375 L0.625,1.5768125 C0.625625,1.4049375 0.765,1.2649375 0.9375,1.2505625 L9.0625,1.2499375 C9.235,1.2499375 9.375,1.4036875 9.375625,1.5755625 C9.375625,1.7493125 9.23625,1.8893125 9.06375,1.8893125 L1.250625,1.8893125 L1.25,13.1118125 L11.25,13.1255625 L11.249375,6.5630625 C11.25,6.3905625 11.39,6.2505625 11.5625,6.2505625 C11.735,6.2505625 11.875,6.3899375 11.875,6.5630625 L11.875625,13.4518125 C11.875625,13.6255625 11.735,13.7643125 11.563125,13.7643125 L11.563125,13.7643125 Z M8.235625,8.3643125 C8.2075,8.3924375 8.174375,8.4155625 8.1375,8.4305625 L8.1325,8.4330625 L8.131875,8.4336875 L5.044375,9.7568125 C5.004375,9.7730625 4.9625,9.7811875 4.92125,9.7811875 C4.84,9.7811875 4.76,9.7493125 4.7,9.6899375 C4.61,9.5993125 4.58375,9.4636875 4.634375,9.3461875 L5.956875,6.2580625 L5.9575,6.2574375 L5.96,6.2518125 C5.975,6.2155625 5.998125,6.1818125 6.02625,6.1549375 L11.55125,0.6286875 L11.551875,0.6280625 L11.5525,0.6274375 L11.555,0.6255625 L0.3125,0.6255625 C0.14,0.6255625 0,0.7655625 0,0.9380625 L0,14.0630625 C0,14.2355625 0.14,14.3755625 0.3125,14.3755625 L12.1875,14.3755625 C12.36,14.3755625 12.5,14.2355625 12.5,14.0630625 L12.5,4.0999375 L8.235625,8.3643125 Z",
    id: "Fill-1315"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1316",
    points: "12.2265625 0.849 12.9196875 0.1465 14.2384375 1.47525 13.5415625 2.17775"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1317",
    points: "11.785875 1.29275 13.11525 2.6215 8.029 7.707125 6.699625 6.39275"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotesIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notes_icon.4a976ffd2337fc8a0690163ef443c7ff.svg";